import { render, staticRenderFns } from "./examComplete.vue?vue&type=template&id=70648717&scoped=true&"
import script from "./examComplete.vue?vue&type=script&lang=js&"
export * from "./examComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70648717",
  null
  
)

export default component.exports